class GridSwitcher extends window.BAO.CustomElement() {
	constructor() {
		super();
	}

	connectedCallback() {
		super.connectedCallback();
		this.headerHeight = this.elements.header.offsetHeight || 0;
	}

	setupListeners() {
		super.setupListeners();

		this.elements = {
			buttons: this.els.button.elements,
			grid: this.externalEls.grid.element,
			header: this.externalEls.header.element
		};

		this.elements.buttons.forEach((button) => {
			button.addEventListener('click', (e) => {
				this.onButtonClick(button);
			});
		});
	}

	clearActiveStates() {
		this.elements.buttons.forEach((button) => {
			button.classList.remove('filter__grid-button--active');
		});
	}

	onButtonClick(el) {
		if (el.classList.contains('filter__grid-button--active')) {
			return;
		}

		const layout = el.dataset.layout;

		if (layout) {
			this.clearActiveStates();
			el.classList.add('filter__grid-button--active');
			this.switchGrid(layout);
			this.updateLayoutKey(layout);
		}
	}

	switchGrid(layout) {
		const switchEvent = new CustomEvent('grid:update', {
			detail: { view: layout },
		});

		const fadeOutProperties = [
			{ filter: 'blur(0px)', opacity: 1 },
			{ filter: 'blur(32px)', opacity: 0 },
		];
		const fadeTiming = { duration: 300 };

		const fadeOutAnimation = this.elements.grid.animate(
			fadeOutProperties,
			fadeTiming,
		);

		fadeOutAnimation.finished.then(() => {
			if (this.elements.grid.getBoundingClientRect().top < this.headerHeight) {
				scrollIntoViewWithOffset(this.elements.grid, this.headerHeight);
			}

			this.elements.grid.dataset.layout = layout;

			const fadeInProperties = fadeOutProperties.slice().reverse();

			this.elements.grid.animate(fadeInProperties, fadeTiming);

			this.dispatchEvent(switchEvent);
		});
	}

	async updateLayoutKey(layout) {
		try {
			const formData = new FormData();
			formData.append('attributes[layout]', layout);

			const response = await fetch('/cart/update.js', {
				method: 'POST',
				body: formData,
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();
			return data.attributes.layout;
		} catch (error) {
			console.error('Error updating the cart:', error);
		}
	}
}

const scrollIntoViewWithOffset = (selector, offset) => {
	window.scrollTo({
		behavior: 'auto',
		top:
			selector.getBoundingClientRect().top -
			document.body.getBoundingClientRect().top -
			offset,
	});
};

if (!customElements.get('grid-switcher')) {
	customElements.define('grid-switcher', GridSwitcher);
}
